import { Injectable } from '@angular/core';
import { AppService, BASE_URL_CRUD, BASE_URL_ACCOUNTING_ACCOUNT, BASE_URL_BULK_UPLOAD } from '../../../app.service';
import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';

// Import RxJs required methods
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

@Injectable()
export class CommonExpensesService extends AppService {

  constructor(http: HttpClient) {
    super(http);
  }

  getExpenseAssign(communityId: number, period: string): Observable<Response> {
    this.endpoint = `${BASE_URL_CRUD}/common-expenses/communities/${communityId}/period/${period}`;
    return this.get(this.endpoint);
  }

  getAccountAssign(communityId: number): Observable<Response> {
    this.endpoint = `${BASE_URL_ACCOUNTING_ACCOUNT}/expense-assignments-accounts`;
    return this.get(this.endpoint);
  }

  getValidationsCloseCommonExpense(communityId: number, period: string): Observable<Response> {
    this.endpoint = `${BASE_URL_CRUD}/common-expenses/${communityId}/period/${period}/validate`;
    return this.get(this.endpoint);
  }

  closePeriod(data, communityId: number, period: string): Observable<Response> {
    this.endpoint = `${BASE_URL_BULK_UPLOAD}/generation/${communityId}/period/${period}`;
    return this.post(this.endpoint, data);
  }

  getCommunityToken(communityId: number): Observable<Response> {
    this.endpoint = `${BASE_URL_BULK_UPLOAD}/enqueue/common-expense/${communityId}/token`;
    return this.get(this.endpoint);
  }

  queueClosePeriod(data, communityId: number, period: string): Observable<Response> {
    this.endpoint = `${BASE_URL_BULK_UPLOAD}/enqueue/common-expense/${communityId}/period/${period}`;
    return this.post(this.endpoint, data);
  }

  openPeriod(communityId: number, period: string, data: any): Observable<Response> {
    this.endpoint = `${BASE_URL_BULK_UPLOAD}/community/${communityId}/period/${period}/open`;
    return this.post(this.endpoint, data);
  }

  getValidationsDeleteBillsReport(communityId: number, type: string): Observable<Response> {
    this.endpoint = `${BASE_URL_BULK_UPLOAD}/report/${communityId}/delete-report/${type}/storage`;
    return this.get(this.endpoint);
  }

  validationToOpenPeriod(communityId: number, period: string): Observable<Response> {
    this.endpoint = `${BASE_URL_BULK_UPLOAD}/communities/${communityId}/period/${period}/check-open`;
    return this.get(this.endpoint);
  }

  releasePeriod(communityId: number, period: string, data: any): Observable<Response> {
    this.endpoint = `${BASE_URL_BULK_UPLOAD}/community/${communityId}/period/${period}/release`;
    return this.post(this.endpoint, data);
  }

  validationToReleasePeriod(communityId: number, period: string): Observable<Response> {
    this.endpoint = `${BASE_URL_BULK_UPLOAD}/communities/${communityId}/period/${period}/check-release`;
    return this.get(this.endpoint);
  }

  validationClosureConfig(communityId: number, period: string): Observable<Response> {
    this.endpoint = `${BASE_URL_BULK_UPLOAD}/communities/${communityId}/period/${period}/valid/config`;
    return this.get(this.endpoint);
  }

  getAllServiceCommonExpense(communityId: number, period: string, sectors: any): Observable<Response> {
    if (!sectors) {
      this.endpoint = `${BASE_URL_CRUD}/communities/${communityId}/common-expense/period/${period}`;
    } else {
      this.endpoint = `${BASE_URL_CRUD}/communities/${communityId}/common-expense/period/${period}?sectors=${sectors}`;
    }
    return this.get(this.endpoint);
  }

  getValidations(communityId: number, period: string): Observable<Response> {
    this.endpoint = `${BASE_URL_CRUD}/communities/${communityId}/period/${period}/valid/config`;
    return this.get(this.endpoint);
  }

  getCloseValidation(communityId: number, period: string): Observable<Response> {
    this.endpoint = `${BASE_URL_CRUD}/communities/${communityId}/period/${period}/valid/close`;
    return this.get(this.endpoint);
  }

  getPeriodValidation(communityId: number): Observable<Response> {
    this.endpoint = `${BASE_URL_CRUD}/communities/${communityId}/valid/period`;
    return this.get(this.endpoint);
  }

  getValidateValidation(communityId: number, period: string): Observable<Response> {
    this.endpoint = `${BASE_URL_CRUD}/communities/${communityId}/period/${period}/valid/validate`;
    return this.get(this.endpoint);
  }

  getControlReceiptValidation(communityId: number): Observable<Response> {
    this.endpoint = `${BASE_URL_CRUD}/communities/${communityId}/valid/control-receipt`;
    return this.get(this.endpoint);
  }

  getControlCheckValidation(communityId: number): Observable<Response> {
    this.endpoint = `${BASE_URL_CRUD}/communities/${communityId}/valid/control-check`;
    return this.get(this.endpoint);
  }

  getUnassignValidation(communityId: number): Observable<Response> {
    this.endpoint = `${BASE_URL_CRUD}/communities/${communityId}/valid/unassign`;
    return this.get(this.endpoint);
  }

  getUnitsQtyValidation(communityId: number): Observable<Response> {
    this.endpoint = `${BASE_URL_CRUD}/communities/${communityId}/valid/units-qty`;
    return this.get(this.endpoint);
  }

  getPropertiesQtyValidation(communityId: number): Observable<Response> {
    this.endpoint = `${BASE_URL_CRUD}/communities/${communityId}/valid/properties-qty`;
    return this.get(this.endpoint);
  }

  getReceiptValidation(communityId: number): Observable<Response> {
    this.endpoint = `${BASE_URL_CRUD}/communities/${communityId}/receipt-book/last-used`;
    return this.get(this.endpoint);
  }

  acceptReceiptValidation(communityId: number): Observable<Response> {
    this.endpoint = `${BASE_URL_CRUD}/communities/${communityId}/receipt-book/last-used`;
    return this.post(this.endpoint, []);
  }

  getNotificationDetail(communityId: number, period: string): Observable<Response> {
    this.endpoint = `${BASE_URL_CRUD}/communities/${communityId}/notification/common-expense/${period}/1/users/null`;
    return this.get(this.endpoint);
  }
  sendNotification(communityId: number, period: string, users: any): Observable<Response> {
    this.endpoint = `${BASE_URL_CRUD}/communities/${communityId}/notification/common-expense/${period}/0/users/${users}`;
    return this.get(this.endpoint);
  }
  getNotificationDetailUnattendedPost(communityId: number, period: string): Observable<any> {
    const data = { properties: [], type: 1 };
    this.endpoint = `${BASE_URL_BULK_UPLOAD}/communities/${communityId}/notification/common-expense/${period}`;
    return this.post(this.endpoint, data);
  }
  // --------- NOT DELETE UNTIL UNATTENDED POST IS IMPLEMENTED
  // sendNotificationPost(communityId: number, period: string, properties: any, pdfParams: any): Observable<any> {
  //   const data = { properties, type: 0 , pdfParams};
  //   this.endpoint = `${BASE_URL_CRUD}/communities/${communityId}/notification/common-expense/${period}`;
  //   return this.post(this.endpoint, data);
  // }
  sendNotificationUnattendedPost(communityId: number, period: string, properties: any, pdfParams: any): Observable<any> {
    const data = { properties, type: 0 , pdfParams};
    this.endpoint = `${BASE_URL_BULK_UPLOAD}/communities/${communityId}/notification/common-expense/${period}`;
    return this.post(this.endpoint, data);
  }
  saveConfig(communityId: number, data): Observable<Response> {
    this.endpoint = `${BASE_URL_CRUD}/communities/${communityId}/set-config-common-expense`;
    return this.put(this.endpoint, data);
  }

  postAnnulmentReceipt(communityId: number, data): Observable<Response> {
    this.endpoint = `${BASE_URL_CRUD}/communities/${communityId}/controls/receipt/annulment`;
    return this.post(this.endpoint, data);
  }

  getCommonExpenseReportUnattended(communityId: number, period: string, sectors: any): Observable<any> {
    if (!sectors) {
      this.endpoint = `${BASE_URL_BULK_UPLOAD}/communities/${communityId}/common-expense-unattended/period/${period}`;
    } else {
      this.endpoint = `${BASE_URL_BULK_UPLOAD}/communities/${communityId}/common-expense-unattended/period/${period}?sectors=${sectors}`;
    }
    return this.get(this.endpoint);
  }

  getCommonExpenseReportUnattendedStatus(communityId: number, period: string): Observable<any> {
    this.endpoint = `${BASE_URL_BULK_UPLOAD}/communities/${communityId}/common-expense-unattended-status/period/${period}`;
    return this.get(this.endpoint);
  }

  getCommonExpenseClosureStatus(communityId: number, period: string): Observable<any> {
    this.endpoint = `${BASE_URL_BULK_UPLOAD}/generation-status/${communityId}/period/${period}`;
    return this.get(this.endpoint);
  }

  getCommonExpenseReleaseStatus(communityId: number, period: string): Observable<any> {
    this.endpoint = `${BASE_URL_BULK_UPLOAD}/release-status/${communityId}/period/${period}`;
    return this.get(this.endpoint);
  }

  getCommonExpenseOpenStatus(communityId: number, period: string): Observable<any> {
    this.endpoint = `${BASE_URL_BULK_UPLOAD}/open-status/${communityId}/period/${period}`;
    return this.get(this.endpoint);
  }

  queueReport(communityId: number, period: string, sectors: any): Observable<any> {
    if (!sectors) {
      this.endpoint = `${BASE_URL_BULK_UPLOAD}/enqueue/common-expense-report/${communityId}/period/${period}`;
    } else {
      this.endpoint = `${BASE_URL_BULK_UPLOAD}/enqueue/common-expense-report/${communityId}/period/${period}?sectors=${sectors}`;
    }
    return this.get(this.endpoint);
  }
}



// WEBPACK FOOTER //
// ./src/app/common-expense/report/common-expenses/common-expenses.service.ts